import React, { useState } from 'react';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl,
    useIntl,
} from 'react-intl';
import { IModalChildProps } from '../../../common/modal-large';
import { IOrderDetails, IOrderUpdateShipTo } from '../../../../models/order';
import './modal-styles.css';
import { RootState } from '../../../../store';
import { connect } from 'react-redux';
import {
    updateShipTo,
    loadOrder,
    updateSelect,
} from '../../../../store/order/order-actions';
import { setIsBusy } from '../../../../store/api/api-status-action';
import Modal from '../../../common/modal';
import { gaEvent } from '../../../../hooks/ga-hook';

interface IPriorAddressModal extends IModalChildProps {
    order: IOrderDetails | null;
    updateShipTo: (updatedShipTo: IOrderUpdateShipTo) => Promise<void>;
    updatedShipTo: IOrderUpdateShipTo;
    loadOrder: (orderNumber: string) => Promise<void>;
    setIsBusy: (isBusy: boolean) => Promise<void>;
    updateSelect: (select: number) => { type: string };
}

const PriorAddressModal = ({
    onAccept,
    onClose,
    order,
    updatedShipTo,
    updateShipTo,
    loadOrder,
    setIsBusy,
    updateSelect,
}: IPriorAddressModal) => {
    const intl = useIntl();
    const [confirmed, setConfirmed] = useState(false);

    const onConfirm = () => {
        gaEvent(
            'Estore_Order_Updates',
            'Prior_Address_Modal_Update',
            order!.billTo.accountNumber
        );

        setIsBusy(true);
        updateShipTo(updatedShipTo).then(() => {
            setIsBusy(false);

            setConfirmed(true);
        });
    };

    const onSubmit = () => {
        loadOrder(order!.orderNumber).then(() => {
            updateSelect(0);
            onClose();
        });
    };

    return (
        <Modal>
            <>
                <div className="modal-header">
                    <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        id="closeModalPriorAddress"
                        aria-label={intl.formatMessage({ id: 'Close' })}
                        onClick={onClose}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h2 className="modal-title">
                        <FormattedMessage
                            id="Change_Shipping_Address"
                            defaultMessage="Change Shipping Address"
                        />
                        *
                    </h2>
                </div>
                <>
                    {confirmed ? (
                        <>
                            <p className="text-center">
                                <span className="fa fa-check icon-green"></span>
                                <strong>
                                    <FormattedMessage
                                        id="Shipping_address_successfully_changed"
                                        defaultMessage="Shipping address successfully changed"
                                    />
                                </strong>
                            </p>
                        </>
                    ) : (
                        <p className="text-center">
                            <strong>
                                <FormattedMessage
                                    id="Are_you_sure_address"
                                    defaultMessage="Are you sure you want to change your
                                    shipping address?"
                                />
                            </strong>
                            <br />
                            <FormattedMessage
                                id="Changing_shipping_impact"
                                defaultMessage="Changing your shipping address may impact your
                                expected delivery time and may include
                                additional charges."
                            />
                        </p>
                    )}
                </>

                <div className="modal-footer">
                    {confirmed ? (
                        <>
                            <button
                                className="btn btn-info"
                                id="closeButtonModalPriorAddress"
                                onClick={onSubmit}
                            >
                                <FormattedMessage
                                    id="Close"
                                    defaultMessage="Close"
                                />
                            </button>
                        </>
                    ) : (
                        <>
                            <button
                                className="btn btn-info"
                                id="cancelButtonModalPriorAddress"
                                onClick={onClose}
                            >
                                <FormattedMessage
                                    id="Cancel"
                                    defaultMessage="Cancel"
                                />
                            </button>
                            <button
                                className="btn btn-info"
                                id="continueButtonModalPriorAddress"
                                onClick={onConfirm}
                            >
                                <FormattedMessage
                                    id="Continue"
                                    defaultMessage="Continue"
                                />
                            </button>
                        </>
                    )}
                </div>
            </>
        </Modal>
    );
};
const mapStateToProps = (state: RootState) => {
    return {
        updateShipTo: state.updateShipTo ? state.updateShipTo.data : null,
        order: state.order ? state.order.data! : null,
        selected: state.select,
    };
};

const mapDispatchToProps = {
    updateShipTo,
    loadOrder,
    setIsBusy,
    updateSelect,
};

const PriorAddressModalContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PriorAddressModal);

export default PriorAddressModalContainer;
